import React, { useEffect, useState } from 'react'
import Loader from '../Loader/Loader';
import { updateUserProfile } from '../../Common/apis';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

function ProfileC({ userData, handleImageChange, setUserData, sideClick }) {
    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        Name: userData?.Name || '',
        Number: userData?.Number || '',
        Email: userData?.Email || '',
        Password: userData?.Password || '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleEditClick = () => {
        setEditMode(true);
    };
    const handleSave = async () => {
        setLoading(true);
        try {
            const res = await updateUserProfile(formData);
            toast.success("Profile updated successfully!");
            setUserData(res?.data)
            setEditMode(false);
        } catch (err) {
            toast.error("Failed to update profile.");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (userData) {
            setFormData({
                Name: userData.Name || '',
                Number: userData.Number || '',
                Email: userData.Email || '',
                Password: userData.Password || '',
            });
        }
    }, [userData]);

    return (
        <>
            {loading ? <Loader /> :
                <div>
                    <div className='flex xl:flex-row flex-col gap-[10px]'>
                        <div className="lg:max-w-[606px] max-w-full w-full">
                            <h6 className="font-[700] font-manrope text-[24px] text-[#000000] pb-[19px]">Profile Status</h6>
                            <div className='bg-[#F6F8FA] relative border border-[#E7E4FC] p-[16px] rounded-[12px]'>
                                <img src="/assets/profile/img1.png" className='rounded-[6px] w-full' alt="" />
                                <div className='absolute top-[36px] cursor-pointer right-[36px]'>
                                    <label
                                        htmlFor="profile-upload"
                                    >
                                        <img src="/assets/profile/item8.svg" alt="" />
                                    </label>
                                    <input
                                        type="file"
                                        id="profile-upload"
                                        accept="image/*"
                                        className="hidden"
                                        onChange={handleImageChange}
                                    />
                                </div>
                                <div className='px-[20px] w-full absolute rounded-b-[6px] py-[10px] bg-[#FF6000] bottom-[16px] lg:max-w-[572px] max-w-[100%] left-[50%] translate-x-[-50%] '>
                                    <button className='w-full text-center font-manrope font-[500] text-[20px] text-[#FFFFFF]'>{userData?.Name || "User Name"}</button>
                                </div>
                            </div>
                        </div>
                        <div className="xl:max-w-[300px] max-w-full w-full">
                            <h6 className="font-[700] font-manrope text-[24px] text-[#000000] pb-[19px]">Credits</h6>
                            <div className='bg-[#F6F8FA] border border-[#E7E4FC] py-[23px] rounded-[12px]'>
                                <p className="font-[500] font-manrope text-[16px] text-center text-[#000000] pb-[52px]">Donation Balance</p>
                                <div className='h-[144px] w-[144px] rounded-full bg-[#FFFFFF] mx-auto flex justify-center items-center' style={{ boxShadow: "0px 0px 20px 0px #0000001A" }}>
                                    <div className='h-[106px] w-[106px] bg-[#F68B29] rounded-full flex flex-col items-center justify-center'>
                                        <img src="/assets/profile/coin.svg" alt="" />
                                        <h6 className="font-[700] font-manrope text-center text-[31px] text-[#FFFFFF]">{userData?.Wallet}</h6>
                                        <p className="text-center font-[400] text-[11px] text-[#FFFFFF]">Credits</p>
                                    </div>
                                </div>
                                <p onClick={sideClick} className="pt-[48px] cursor-pointer font-manrope font-[500] text-center underline text-[16px] text-[#FF6000]">Get More Credits</p>
                            </div>
                        </div>
                    </div>
                    <div className='bg-[#F6F8FA] border border-[#E7E4FC] relative rounded-[12px] p-[20px] mt-[20px]'>
                        <img src="/assets/profile/edit.svg" onClick={handleEditClick}
                            className='absolute cursor-pointer top-[16px] right-[16px]' alt="" />
                        <div>
                            <h6 className="font-[500] font-manrope text-[20px] text-[#000000] pb-[16px]">Account</h6>
                            <div className='grid grid-cols-2 gap-x-[10px] gap-y-[13px]'>
                                <h6 className="font-[400] font-manrope text-[14px] text-[#000000]">Full Name</h6>
                                {editMode ? (
                                    <input
                                        name="Name"
                                        value={formData.Name}
                                        onChange={handleChange}
                                        className="border border-gray-300 rounded px-2 py-1 text-[14px]"
                                    />
                                ) : (
                                    <p className="font-[700] font-manrope text-[14px] text-[#000000]">
                                        {userData?.Name || "User Name"}
                                    </p>
                                )}
                                <h6 className="font-[400] font-manrope text-[14px] text-[#000000]">Mobile</h6>
                                {editMode ? (
                                    <input
                                        name="Number"
                                        value={formData.Number}
                                        onChange={handleChange}
                                        maxLength="10"
                                        className="border border-gray-300 rounded px-2 py-1 text-[14px]"
                                    />
                                ) : (
                                    <p className="font-[700] font-manrope text-[14px] text-[#000000]">
                                        {userData?.Number || "User Number"}
                                    </p>
                                )}
                                <h6 className="font-[400] font-manrope text-[14px] text-[#000000]">Email ID</h6>
                                {editMode ? (
                                    <input
                                        name="Email"
                                        value={formData.Email}
                                        onChange={handleChange}
                                        className="border border-gray-300 rounded px-2 py-1 text-[14px]"
                                    />
                                ) : (
                                    <p className="font-[700] font-manrope text-[14px] text-[#000000]">
                                        {userData?.Email || "User Email Id"}
                                    </p>
                                )}

                                <h6 className="font-[400] font-manrope text-[14px] text-[#000000]">Password</h6>
                                <p className="font-[700] font-manrope text-[14px] text-[#000000]">
                                    {userData?.Password ? '**********' : 'User Email Id'}
                                </p>
                                <div className='mt-[20px] lg:block hidden'>
                                    <button onClick={handleSave} className='d-btn w-full text-center'>SAVE CHANGES</button>
                                </div>
                            </div>
                            <div className='mt-[20px] block lg:hidden'>
                                <button onClick={handleSave} className='d-btn w-full text-center'>SAVE CHANGES</button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default ProfileC